import chalk from "chalk";
import * as readline from 'readline';

export const createPrompt = () => {
  return readline.createInterface({
    input: process.stdin,
    output: process.stdout
  });
};

export const prompt = (question: string): Promise<string> => {
  const rl = createPrompt();

  return new Promise((resolve) => {
    rl.question(question, (answer) => {
      rl.close();
      resolve(answer.trim());
    });
  });
};

export const promptWithValidation = async (
  question: string,
  validator: (input: string) => boolean | string,
  errorMessage?: string
): Promise<string> => {
  while (true) {
    const answer = await prompt(question);
    const validation = validator(answer);

    if (validation === true) {
      return answer;
    }

    const error = typeof validation === 'string' ? validation : errorMessage;
    if (error) {
      console.log(chalk.red(`❌ ${error}`));
    }
  }
};